import { get as _get } from '../utilities/common';
import { recentSearchDuck } from '../ducks';
import { getBycOwners } from '../utilities';

export default function getOwnersAndFilters() {
    return async (ctx) => {
        const fetchOptions = {};

        if (ctx.req) {
            // add cookie to headers so we don't lose it on the server
            fetchOptions.headers = {
                cookie: ctx.req.headers.cookie,
            };
        }

        // TODO: bonnet-atc - should this be pared down to only the query params we care about?
        // remove location and dma data from the query
        // eslint-disable-next-line no-unused-vars
        const { location = {}, dma, ...query } = ctx.query;

        // add zip to the query if it exists
        if (location.zip) {
            query.zip = location.zip;
        }
        const [, { channel }] = ctx.useFeature('brand');
        query.channel = channel || ctx.data.brand.toUpperCase();

        const dealerQuery = {
            makeCode: query.makeCode,
            modelCode: query.modelCode,
            listingType: query.listingType,
            trimCode: query.trimCode,
            seriesCode: query.seriesCode,
            zip: query.zip,
            channel: query.channel,
        };

        if (!dealerQuery.makeCode && !dealerQuery.listingType) {
            // use recent searches
            const recentSearches = recentSearchDuck.selectors.getRecentSearches(ctx.store.getState());
            if (recentSearches && recentSearches.length > 0) {
                const { makeCodeList, modelCodeList, listingTypes, trimCodeList, seriesCodeList } = _get(recentSearches[0], 'query', {});

                dealerQuery.makeCode = makeCodeList;
                dealerQuery.modelCode = modelCodeList;
                dealerQuery.listingType = listingTypes;
                dealerQuery.trimCode = trimCodeList;
                dealerQuery.seriesCode = seriesCodeList;
            }
        }

        // call out to BYC Owners / dealer list for dealers
        const bycOwners = await getBycOwners(dealerQuery, query);
        Object.assign(ctx.data, { ...bycOwners });
    };
}
